import { ReactComponent as TempIcon } from "assets/svgs/Temperature.svg";

const TemperatureIcon = ({
    className = "",
    temperature,
    showTemperature = true,
    reverse = true,
}) => {
    const hasNumeric = typeof temperature === "number" && !Number.isNaN(temperature);

    let icon;
    let valueClassName = "";
    if (hasNumeric) {
        if (temperature > 80.0) {
            icon = <TempIcon className="text-warning" />;
            valueClassName = "text-warning";
        } else {
            icon = <TempIcon />;
            valueClassName = "text-white";
        }
    } else {
        icon = <TempIcon className="text-black70" />;
        valueClassName = "text-black70";
    }

    return (
        <div
            className={`flex items-center gap-px ${className} ${
                reverse ? "-reverse" : ""
            }`}
        >
            {icon}
            {showTemperature && (
                <p className={`flex items-baseline gap-0.5 text-h5 leading-none ${valueClassName}`}>
                    <span className="tabular-nums">
                        {hasNumeric ? temperature.toFixed(1) : "—"}
                    </span>
                    {hasNumeric && <span className="shrink-0">°C</span>}
                </p>
            )}
        </div>
    );
};

export default TemperatureIcon;
